<template>
  <div class="upload-bd">
    <div class="upload-box" :class="{'small': size === 'small'}">
      <i v-if="!disabled" class="icon icon-add"></i>
      <img v-if='imageUrl' :src="imageUrl">
      <input v-if="!disabled" name="file" accept="image/*" type="file" @change="filesChange($event)" />
    </div>
    <div class="delete" :class="{'small': size === 'small'}" v-if='!disabled&&imageUrl' @click="deleteImage">
      <i class="icon icon-delete"></i>
    </div>
    <slot></slot>
  </div>
</template>
<script>
/**
   * @param url [Array] 显示图片地址
   * @param size [String] 大小 small（0.55rem）, defaule（0.75rem）
   * @param disabled [Boolean]  是否可编辑（即不能触发添加事件）
   * @param button [Boolean] 是否只是添加按钮,但能触发添加事件与disabled不冲突
   * @param change [Function] 触发添加事件，参数为添加的文件
   * @param delete [Function] 点击删除事件
   *
   * @example
   *
    <t-upload @change=""></t-upload>
   */
export default {
  name: 'tUpload',
  props: {
    url: { type: String, default: '' }, // 显示图片地址
    size: { type: String, default: '' }, // 大小 small, defaule
    disabled: { type: Boolean, default: false }, // 是否可编辑
    button: { type: Boolean, default: false }, // 是否只是添加按钮
  },
  data() {
    return {
      imageUrl: this.url,
    };
  },
  mounted: function () {},
  methods: {
    filesChange: function (event) {
      const targetFile = event.target.files[0];
      targetFile.base64 = window.URL.createObjectURL(targetFile);
      this.imageUrl = this.button ? '' : targetFile.base64;
      this.$emit('change', targetFile);
    },
    deleteImage: function () {
      this.imageUrl = '';
      this.$emit('delete');
    },
  },
};

</script>
<style lang="scss">
.upload-bd {
  display: inline-block;
  padding-top: 0.06rem;
  padding-right: 0.06rem;
  position: relative;
  .upload-box {
    width: 0.75rem;
    height: 0.75rem;
    line-height: 0.75rem;
    color: #ffffff;
    background-color: #D8D8D8;
    text-align: center;
    overflow: hidden;
    border-radius: 4px;
    position: relative;
    font-size: 0.28rem;
    i {
      font-size: 0.38rem;
    }
    &.small {
      width: 0.55rem;
      height: 0.55rem;
      line-height: 0.55rem;
      i {
        font-size: 0.26rem;
      }
    }
    input {
      opacity: 0;
      z-index: 6;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    img {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 3;
    }
  }
  .delete {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 7;
    border-radius: 50%;
    i {
      color: #4086F5;
      font-size: 0.26rem;
      display: block;
      height: 0.26rem;
      width: 0.26rem;
      margin-top: -0.02rem;
      margin-left: -0.02rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: 0.04rem;
        top: 0.04rem;
        bottom: 0.04rem;
        right: 0.04rem;
        z-index: -1;
        background-color: #ffffff;
        border-radius: 50%;
      }
    }
    &.small {
      i {
        display: block;
        font-size: 0.22rem;
        height: 0.22rem;
        width: 0.22rem;
        margin-top: -0.01rem;
        margin-left: -0.01rem;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/upload.vue